import gql from 'graphql-tag';

const upsertRuleNoteMutation = gql`
  mutation UpsertRuleNote($input: UpsertRuleNoteInput!) {
    upsertRuleNote(input: $input) {
      success
    }
  }
`;

export default upsertRuleNoteMutation;
